// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_removeTeamMarketingProfileTeamPhoto(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamMarketingProfileTeamPhotoRemoved"]);
}

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"removeTeamMarketingProfileTeamPhoto_TeamMarketingProfileTeamPhotoRemoved_marketingProfile":{"f":""},"removeTeamMarketingProfileTeamPhoto":{"u":"response_removeTeamMarketingProfileTeamPhoto"}}};

var wrapResponseConverterMap = {
  response_removeTeamMarketingProfileTeamPhoto: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"removeTeamMarketingProfileTeamPhoto_TeamMarketingProfileTeamPhotoRemoved_marketingProfile":{"f":""},"removeTeamMarketingProfileTeamPhoto":{"u":"response_removeTeamMarketingProfileTeamPhoto"}}};

var responseConverterMap = {
  response_removeTeamMarketingProfileTeamPhoto: unwrap_response_removeTeamMarketingProfileTeamPhoto
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamMarketingProfileTeamPhotoForm_RemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeTeamMarketingProfileTeamPhoto",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamMarketingProfileTeamPhotoForm_teamMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileTeamPhotoRemoved",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "TeamMarketingProfileTeamPhotoForm_RemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeTeamMarketingProfileTeamPhoto",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "teamPhoto",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "ratio",
                            "variableName": "__relay_internal__pv__DevicePixelRatio"
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 400
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileTeamPhotoRemoved",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "653776f260392126dbfd818d45b3f501",
    "id": null,
    "metadata": {},
    "name": "TeamMarketingProfileTeamPhotoForm_RemoveMutation",
    "operationKind": "mutation",
    "text": "mutation TeamMarketingProfileTeamPhotoForm_RemoveMutation(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  removeTeamMarketingProfileTeamPhoto {\n    __typename\n    ... on TeamMarketingProfileTeamPhotoRemoved {\n      marketingProfile {\n        ...TeamMarketingProfileTeamPhotoForm_teamMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment TeamMarketingProfileTeamPhotoForm_teamMarketingProfile on TeamMarketingProfile {\n  teamPhoto {\n    url(width: 400, ratio: $__relay_internal__pv__DevicePixelRatio)\n    height\n    width\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

var wrap_response_removeTeamMarketingProfileTeamPhoto = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_removeTeamMarketingProfileTeamPhoto = unwrap_response_removeTeamMarketingProfileTeamPhoto;
exports.wrap_response_removeTeamMarketingProfileTeamPhoto = wrap_response_removeTeamMarketingProfileTeamPhoto;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
